import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { sntTranslate } from "src/app/support/translate";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import { isPlainObject } from "lodash-es";
import {
  NOTIFICATION_PRIORITY,
  NotificationService
} from "src/app/services/notification.service";
import { nextRuntimeId } from "src/app/support/runtime-id";
import { dateUtil } from "src/app/support/date-util";

@Injectable()
export class RoleInterceptor implements HttpInterceptor {
  private readonly notificationService = inject(NotificationService);

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    switch (req.method.toUpperCase()) {
      case "PATCH":
      case "PUT":
      case "DELETE":
      case "POST": {
        return next.handle(req).pipe(
          catchError((errorResponse) => {
            if (
              errorResponse instanceof HttpErrorResponse &&
              errorResponse.status === 403
            ) {
              this.notificationService.publish({
                message: sntTranslate(marker("Operazione non permessa")),

                sent: dateUtil().toISOString(),
                type: "warning",
                priority: NOTIFICATION_PRIORITY.LOW,
                id: nextRuntimeId()
              });

              return throwError(
                new HttpErrorResponse({
                  url: errorResponse.url,
                  error:
                    errorResponse.error && isPlainObject(errorResponse.error)
                      ? {
                          ...errorResponse.error,
                          message: sntTranslate(
                            marker("Operazione non permessa")
                          )
                        }
                      : {
                          message: sntTranslate(
                            marker("Operazione non permessa")
                          )
                        },
                  headers: errorResponse.headers,
                  status: errorResponse.status,
                  statusText: errorResponse.statusText
                })
              );
            }

            return throwError(errorResponse);
          })
        );
      }
      default: {
        return next.handle(req);
      }
    }
  }
}
